<template>
    <div class="ei-counter">
        <button @click="subtract" :disabled="isAnimating">-</button>
        <div :class="{'middle-num':true,before:isBefore,after:isAfter}" :data-before="countBefore"
             :data-after="countAfter">
            <div class="middle-num-current" @click="showInput">{{count}}</div>
        </div>
        <div class="middle-input" v-show="inputVisible">
            <input v-model="count" @blur="showDiv" ref="saveCountInput" style="caret: #fff underscore"/>
        </div>
        <button @click="add" :disabled="isAnimating">+</button>
    </div>
</template>

<script>
    export default {
        name: "EiCounter",
        data() {
            return {
                count: 0,
                countBefore: 0,
                countAfter: 0,
                isBefore: false,
                isAfter: false,
                inputVisible: false
            }
        },
        props: {
            start: {
                type: Number,
                default: 0
            },
            end: {
                type: Number,
                required: true
            }
        },
        computed: {
            isAnimating() {
                return this.isBefore || this.isAfter
            }
        },
        created() {
            this.count = this.start
            this.countBefore = this.count - 1
            this.countAfter = this.count + 1
        },
        methods: {
            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveCountInput.focus();
                });
            },
            showDiv() {
                this.inputVisible = false
            },
            subtract() {
                this.isBefore = true
                setTimeout(() => {
                    if (this.count === this.start) {
                        this.count = this.end
                    } else {
                        this.count--
                    }
                    this.countBefore = this.count - 1
                    this.countAfter = this.count + 1
                    this.isBefore = false
                }, 200)
            },
            add() {
                this.isAfter = true
                setTimeout(() => {
                    if (this.count === this.end) {
                        this.count = this.start
                    } else {
                        this.count++
                    }
                    this.countBefore = this.count - 1
                    this.countAfter = this.count + 1
                    this.isAfter = false
                }, 200)
            }
        }
    }
</script>

<style scoped lang="scss">
    $cHeight: 40px;
    $cPadding: 0px;
    .ei-counter {
        width: 100px;
        height: $cHeight;
        background-color: #000000;
        display: block;
        overflow: hidden;
        position: relative;
        padding-top: $cPadding;
        padding-bottom: $cPadding;
        z-index: 2;

        /*&:after {*/
        /*    content: "";*/
        /*    position: absolute;*/
        /*    top: 0;*/
        /*    left: 0;*/
        /*    background: linear-gradient(180deg, rgba(0, 0, 0, .9) 0%, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, .9) 100%);*/
        /*    width: 100%;*/
        /*    height: 100%;*/
        /*    z-index: 1;*/
        /*}*/

        .middle-num {
            margin: -$cHeight auto;
            display: block;
            width: 80%;
            color: #fff;
            font-size: 30px;
            line-height: $cHeight;
            text-align: center;
            z-index: 3;

            .middle-num-current {
                display: block;
                width: 100%;
                height: $cHeight;
                cursor: pointer;
                z-index: 4;
            }

            &::before {
                display: block;
                content: attr(data-before);
            }

            &::after {
                display: block;
                content: attr(data-after);
            }

            &.before {
                transform: translateY($cHeight);
                transition: transform 200ms ease-in;
            }

            &.after {
                transform: translateY(-$cHeight);
                transition: transform 200ms ease-in;
            }
        }

        .middle-input {
            margin: 0 auto;
            display: block;
            width: 80%;
            height: $cHeight;
            top: 0;
            left: 16px;
            position: absolute;


            input {
                width: 80%;
                height: 100%;
                font-size: 30px;
                text-align: center;
                background-color: #DE404D;
                color: #fff;
                border: none;
                outline: none;
            }

        }

        button {
            display: inline-block;
            background: none;
            color: #fff;
            font-size: 20px;
            line-height: $cHeight;
            padding: 0;
            margin: 0;
            width: 10px;
            height: 10px;
            outline: none;
            z-index: 3;

            &:first-child {
                position: absolute;
                top: $cPadding;
                left: 3px;
            }

            &:last-child {
                position: absolute;
                top: $cPadding;
                right: 3px;
            }
        }

    }

</style>
